<ng-container
  *ngFor="let state of postReservationStatesArray;trackBy: stateTrack; let last = last; let index = index">

  <div class="d-flex align-items-center justify-content-between py-4 gap-16 pointer px-3 px-sm-4"
       (click)="goTo(state)"
       (mouseenter)="onItemMouseEnter(state)"
       (mouseleave)="onItemMouseLeave()">
    <div class="pills subtitle_2 text-center position-relative ms-sm-2">
            <span>
              {{ index + 1 }}
            </span>
    </div>

    <div class="flex-grow-1">
      <hgroup>
        <h2 class="title_2">
          {{ state['title_' + locale] }}
          <ng-container *ngIf="state['childs'] && state['childs'].length > 0">
            <div *ngFor="let subState of state['childs']; let last = last; trackBy:stateTrack">
              {{ subState['title_' + locale] }}
            </div>
          </ng-container>
        </h2>
        <p class="text_2" [innerHTML]="state['timeline_' + locale]"></p>
      </hgroup>
    </div>
    <button id="post_reservation-next_step_button" aria-label="Button : Go to next step"
            class="btn border-0 px-0 me-sm-2" type="button">
      <lf-icon name="blueGradRightChevron" height="25px" width="25px"></lf-icon>
    </button>
  </div>

  <hr *ngIf="!last">
</ng-container>

